export default __webpack_public_path__ + "static/media/dash.40c5dded.png";